import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const AudioFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AudioFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.94 10.57c-.03-.12-.07-.23-.12-.34v-.1c-.06-.11-.14-.21-.22-.3l-7.53-7.49a1.5 1.5 0 0 0-.29-.22h-.11a2 2 0 0 0-.33-.12h-9.6C9.43 2 7.56 3.86 7.53 6.17v3.67c-3.78.82-6.17 4.55-5.35 8.33a6.98 6.98 0 0 0 5.35 5.35v2.75c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.58h-.03ZM9.11 19.03c.02-.82.7-1.47 1.52-1.45.15 0 .31.03.46.07v-3.43a.44.44 0 0 0-.44-.45h-.08l-2.6.39c-.22.03-.39.22-.39.45v4.94c-.02.82-.71 1.47-1.53 1.45-.81 0-1.46-.65-1.46-1.46s.65-1.46 1.46-1.46c.15 0 .31.03.46.07v-5.09c0-.23.16-.42.39-.46l4.74-.71c.26-.03.49.15.52.41v6.71c-.07.84-.8 1.47-1.65 1.4-.75-.06-1.34-.65-1.4-1.4v.03Zm18.02 7.23c0 .77-.76.97-1.4.97H11.75c-.64 0-1.4-.17-1.4-.97v-2.72a6.99 6.99 0 0 0 5.57-8.17 6.97 6.97 0 0 0-5.57-5.57V6.16c0-.77.61-1.4 1.38-1.4h8V9.9c0 1.29 1.05 2.34 2.34 2.34h5.06z"
    })
  }));
};